import React from 'react';
import PropTypes from 'prop-types';
import { Row, Image } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import Styles from './styles';

const EditorButtonRow = ({
  resetState,
  editionStep,
  changeEditionStep,
  item,
  atlasImage,
  structureEnabled
}) => (
  <Row style={{ height: '80px' }} className="border-bottom mb-1 pt-1 pb-2 mx-0">
    <Styles.ColButton selected={false} xs={3} className="h-100" onClick={resetState}>
      {item === 'graphic' && <FontAwesomeIcon icon="chart-pie" size="lg" />}
      {item === 'atlas' && <Image className="h-100" src={atlasImage} />}
    </Styles.ColButton>
    <Styles.ColButton
      selected={editionStep === 1}
      xs={3}
      className="h-100"
      disabled={!structureEnabled}
      onClick={() => changeEditionStep(1)}
    >
      {item === 'graphic' && (editionStep === 1 ? 'Attributes' : 'A')}
      {item === 'atlas' && 'Structure'}
    </Styles.ColButton>
    {editionStep > 1 && (
      <Styles.ColButton
        selected={editionStep === 2}
        xs={3}
        className="h-100"
        onClick={() => changeEditionStep(2)}
      >
        <FontAwesomeIcon icon="palette" size="lg" />
      </Styles.ColButton>
    )}
    {editionStep > 2 && (
      <Styles.ColButton
        selected={editionStep === 3}
        xs={3}
        className="h-100"
        onClick={() => changeEditionStep(3)}
      >
        {item === 'graphic' && <FontAwesomeIcon icon="list-ul" size="lg" />}
        {item === 'atlas' && 'Content'}
      </Styles.ColButton>
    )}
  </Row>
);
EditorButtonRow.defaultProps = {
  atlasImage: '',
  structureEnabled: true
};
EditorButtonRow.propTypes = {
  atlasImage: PropTypes.string,
  structureEnabled: PropTypes.bool,
  item: PropTypes.string.isRequired,
  resetState: PropTypes.func.isRequired,
  editionStep: PropTypes.number.isRequired,
  changeEditionStep: PropTypes.func.isRequired
};

export default EditorButtonRow;
